import styled from 'styled-components';

export const TextRed = styled.span`
  color: red;
`;

export const Wrapper = styled.div<{ padding?: string; marginB?: string; bg?: string }>`
  width: 100%;
  max-width: 40rem;
  border-radius: 0.5rem;
  border-style: dashed;
  border-width: 2px;
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: ${(props) => props.padding || '0'};
  margin-bottom: ${(props) => props.marginB || '0'};
  background: ${(props) => props.bg};
`;

export const Box = styled.div`
  width: 100%;
  max-width: 40rem;
  border-radius: 0.5rem;
  padding: 1rem;
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 3rem;
`;

export const VoiceIndicator = styled.div`
  width: 80px;
  display: flex;
  justify-content: center;
  padding: 1rem;
  border-left: 2px dashed #e5e7eb;
`;
